import { AUTH_MODE, CART_MODE } from '@src/components/Checkout/constants';

import type { CheckoutMode } from '../types';

export const canManageCheckoutCoupon = (
  checkoutMode: CheckoutMode,
  canManageCartCoupon: boolean,
  isLoggedIn: boolean,
) => {
  if (!canManageCartCoupon) {
    return false;
  }

  if (checkoutMode === CART_MODE) {
    return true;
  }

  if (checkoutMode === AUTH_MODE) {
    return !isLoggedIn;
  }

  return false;
};

export default canManageCheckoutCoupon;
